export default {
    //首页
    home: {
        nav: {
            Home: 'Home',
            Technologies: 'Technologies',
            Products: "Products",
            AboutUs: "About Us",
            Newsroom: "Newsroom"
        },
        childrenNav: {
            FaceRecognition: "Face Recognition",
            ProductequiPment: "Aftermarket Active Safety Equipment",//后装主动安全硬件产品
            PreinstalledSolution: "Pre-installed Active Safety Equipment",//前装主动安全硬件产品
            sdk:"Active Safety SDK",//主动安全SDK
            CloudPlatform: "Vehicles Management Cloud Platform",//车辆管理云平台
            About: "About Us",
            Joinus: "Join Us"
        },
        grandchildrenNav:{
            KYLFD:"KY-LFD Active Safety Equipment for Commercial Vehicle",//KY-LFD商用车主动安全设备
            Polaris:"KY-BJX Polaris Intelligent Driving Recorder",//Polaris北极星智能行车记录仪
            KYJLY:"KY-JLY Active Safety Intelligent Recorder",//KY-JLY主动安全智能记录仪
            KYHSj:"KY-HSJ Active Safety Rearview Mirror",//KY-HS]主动安全智能后视镜
            HDDashcam:"HD Dashcam",//高清行车记录仪
            Intelligent:"Intelligent Automotive Core Board",//智能车载核心板
            installedADAS:"Pre- installed ADAS Driver Recorder",//前装ADAS产品
            installedDMS:"Pre-installed DMS Camcorder",//前装DMS产品
            Genera:"General ADAS SDK",//标准版ADAS SDK
            Dashcam:"Dashcam ADAS SDK",//行车记录仪专用ADAS SDK
            Professional:"Professional SDK",//升级版SDK
            YKYVehicles:"YKY Vehicles Management Platform"//易开云车辆管理平台
        },
        hometop: "Intelligent Driving Solution Provider",
        homecenter: "Learn More",
        homebottom: "Partners"
    },
    //页面下方地址以及联系方式
    address: {
        tel: "Tel: +86-10-53686837",
        Business: "Business Cooperation：bd@adasplus.com",
        JoinUs: "Join Us：https://www.lagou.com/gongsi/j141699.html",
        Beijing: "Beijing: 5F, Building 11, No. 18 Ziyue Road, Chaoyang District, Beijing",
        Shenzhen: "Shenzhen: 2F, Chuangyi Building, No. 3025, Nanhai Ave., Nanshan Dist., Shenzhen",
        // Shenzhen: "Shenzhen: 2F, Chuangyi Bldg., Nantou St., Nanshan Dist., Shenzhen",
        // Taiwan: "Taiwan: No. 10, Aly. 2, Ln. 135, Xuefu Rd., South Dist., Taichung, Taiwan",
        Taiwan: "Taiwan: 4F.-5, No. 292, Renhe Rd., South Dist., Taichung City 402, Taiwan ",
        Changsha: "Changsha: No. 18025, bldg. 1, B1E1, Fenghuang Tianjie garden, Beichen Delta, Kaifu Dist., Changsha",
        enterpriseName:"Key (Beijing) Technology Co., Ltd."

    },
    //技术页
    Technologies: {
        TechnologiesTop: "New Driving Experience Driven by Technology",
        TechnologiesAdas: "Advanced driver assistant systems can detect vehicles, pedestrians, and lanes based on the digital camera to alert the driver to the potential risk in time.",
        Technologiesvideo: "ADAS Demo Video",
        ADAStext: {
            LDW: "",
            FCW: "",
            PCW: "",
            HW: "",
            SG: "",
            TSR: ""
        },
        DMS: {
            DMStext: "The system is capable of detecting the driving status effectively according to the expression, gesture and action of drivers in real time. And it will give a timely warning to the driver who has the following dangerous behavior.",
            Distraction: "Distraction",
            Calling: "Calling",
            Tired: "Tired",
            Smoking: "Smoking",
        },
        Face: {
            FaceRecognition: "Face Recognition",
            Takingpictures: "Taking pictures",
            Uploadingpictures: "Uploading pictures",
            FaceVerification: "Face Verification",
            Informationfeedback: "Information feedback",
            ClickHere: "Click Here To Test",
            HeadCounting: "Head Counting",
            HeadCountingtext: "It can count the number of people within the car based on the face recognition, and can also make the record of the situation in car by taking pictures for further checking whenever you need.",
            IntrusionWarning: "Intrusion Warning",
            IntrusionWarningtext: "Users can set up a blacklist or a whitelist. When someone inside the blacklist or outside the whitelist appears in the car, a warning will be given."
        }
    },
    //产品页
    Products: {
        ProductsTop: "Software and Hardware Products Based on Independent R&D",
        commercial: {
            Active: "Active Safety Equipment for Commercial Vehicle",
            ActiveKYLFD: "KY-LFD ( Advanced Driver Assistant Equipment )",
            ActiveKYLFDtext: "The industrial standard of JT/T 1094-2016 was implemented by Chinese government in 2017, requiring commercial bus longer than 9 meters to be equipped with the safety system in accordance with JT/T 833-2014. ADASPLUS products have already passed the JT/T833-2014 successfully.",
            ActiveKYLFDbottom: "Host Machine of the Equipment",
            function: "Functions:",
            commercialAdas: "1. ADAS Warning: Before the occurrence of danger, The equipment will give the front collision warning and lane departure warning in time to reduce the potential collision risk;",
            commercialtired: "2. Driving Fatigue Prevention: An early warning will be sent to the driver while the driver has a safety hazard such as distraction or fatigue.",
            camera: "Deputy Machine of the Equipment"
        },
        front: {
            fronttitle: "Solutions for the Factory-installed Product",
            frontadas: "KY101 (Intelligent Driver Assistant System)",
            Features: "Features:",
            Featurestext: " Based on the real-time identification of vehicles, pedestrians and lanes in front, the system is capable of detecting the distance and relative speed between the vehicle and front targets, and thus making the warning judgement. ",
            Featuresbottom: "Factory-installed Product",
        },
        SDK: {
            sdkpone: "ADASPLUS has been in cooperation with many well-known enterprises to provide the SDK that support a comprehensive suite of ADAS and DMS functions for their intelligent rearview mirrors and head unit.",
            sdkptwo: "",
            sdkpthree: "The product has high accuracy rate and low false negative rate, and could effectively reduce CPU and memory usage.",
            sdkpfour: "So far, we have already reached millions of users.",
            Factory: "Pre-installed ADAS",
            Dash: "Dash Cam+ADAS",
            Intelligent: "Rearview Mirror+ADAS",
            Navigation: "Car Navigation+ADAS"
        },
        service: {
            servicetitle: "Cloud Platform",
            servicetext: "The platform supports clients to manage the data relevant to vehicles，drivers, and roads more efficiently and more conveniently from multiple dimensions. In addition, each dangerous driving behavior will be recorded to prevent the potential risks, thereby improving the safety of drivers and vehicles. In order to provide users with a better experience, more functions are under development."
        }
    },
    //关于我们
    about: {
        abouttitle: "Aim High and Move Forward Bravely",
        company: "About Us",
        companytext: "ADASPLUS, founded in 2016, was composed of Dr. and Chinese senior experts. The company has now formed a set of integrated system of algorithms, products, hardware, design and operations. ADASPLUS provides a high accuracy security algorithm of advanced driving assistant system with image recognition, machine learning and artificial intelligence technology. We do not only focus on the pre-installed ADAS algorithm, but also design the algorithm for after loading, providing ADAS SDK for vehicle intelligence hardware to achieve the accurate active safety function.",
        companybottom: "Our Vision: New Driving Experience Driven by Technology",
        Joinus: "Join Us",
        Joinustext: "Since ADASPLUS is growing at a high speed, we welcome more ambitious talents to join us and move forward together in the field of intelligent driving.",
        Joinuslook: "                               Learn More",
    },
    //新闻
    Journalism: {
        Journalismtitle: "Pragmatic and Innovative",
        new: "News"
    }
}


// WEBPACK FOOTER //
// ./src/i18n/English.js